var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');

module.exports = function (target, key, value, options) {
  if (options && options.enumerable) target[key] = value;
  else createNonEnumerableProperty(target, key, value);
};



// WEBPACK FOOTER //
// webpack://idx/node_modules/core-js-pure/internals/redefine.js